import { useLazyQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/styles';
import CustomLayout from 'component/layout/custom_layout';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import appProval from '../../../assets/img/approval.png';
import UserType from '../../../constants/user';
import { useAuth } from '../../../contexts/AuthContext';
import { authenticationActions } from '../../../redux/authentication/authentication.slice';
import { getMe } from '../../../redux/authentication/user_detail';
const useStyles = makeStyles({
    backgroundHome: {
        backgroundImage: `url(${appProval})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    logoBox: {
        height: '56px',
        display: 'flex',
        padding: '0 28px',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logo: {
        width: '45px',
    },
    overlay: {
        background: '#000',
        width: '100%',
        position: 'absolute',
        left: 0,
        zIndex: 99,
        top: 0,
        opacity: '0.5',
    },
    sideBar: {
        position: 'fixed',
        '@media (min-width: 1024px)': {
            position: 'absolute',
        },
        width: 'auto',
        left: 0,
        zIndex: 100,
        top: 0,
        bottom: 0,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
    h3Text: {
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '32px',
        lineHeight: '44px',
        margin: '16px auto',
        color: '#FFF',
        width: '348px',
        textAlign: 'center',
    },
    pText: {
        fontFamily: 'PoppinsRegular',
        color: '#FFF',
        fontSize: '16px',
        lineHeight: '24px',
        width: '307px',
        margin: '0 auto calc(15vh)',
        textAlign: 'center',
    },
});
function HomeWaiting() {
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();
    const { currentUser } = useAuth();
    const onGetDataCustomerComplete = (response: any) => {
        dispatch(getMe(response.me));
        dispatch(authenticationActions.setApproved(response.me.approved));
        if (response.me && response.me.userType === UserType.Customer) {
            history.push(PATH.QUIZ_MANAGER);
        } else {
            history.push(PATH.HOME);
        }
    };
    const [dataConfig] = useLazyQuery(USER_DETAIL, {
        onCompleted(response) {
            onGetDataCustomerComplete(response);
        },
        onError(error) {
            console.log('get data Failed: ', error);
        },
    });

    useEffect(() => {
        if (currentUser) {
            dataConfig();
        }
    }, [currentUser, dataConfig]);

    return (
        <CustomLayout className={classes.backgroundHome} showSideBarBtn={true} hideBottomNav={true}>
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    height: '100%',
                    textAlign: 'center',
                }}
            >
                <h3 className={classes.h3Text}>Thank you for your interest in Taffi!</h3>
                <p className={classes.pText}>
                    We have received your request and we will get back to you within 48 hours
                </p>
            </div>
        </CustomLayout>
    );
}

export default HomeWaiting;
